// extracted by mini-css-extract-plugin
export default {"supportBlock":"oOCPq","title":"BNf7-","titleThin":"iuZZn","description":"xfliP","chatVideo":"XOzYC","downloadButton":"_8Ohrf","skeleton-progress":"N4Yty"};